import React from "react";
import { Link } from "react-router-dom";


// Background image
import serviceBg from "../../images/bg/service-gradient-bg.png";
 
// Service images

import blockchainDevelopmentImg from "../../images/ServicePageImg/Blockchain Development.png";
import blockchainConsultingImg from "../../images/ServicePageImg/Blockchain Consulting.png";

import centralizedCryptoExchangeImg from "../../images/ServicePageImg/Centralized Crypto Exchange.png";
import decentralizedCryptoExchangeImg from "../../images/ServicePageImg/Decentralized Crypto Exchange.png";

import cryptoListingServicesImg from "../../images/ServicePageImg/Crypto Listing Services.png";
import cryptoMarketingImg from "../../images/ServicePageImg/Crypto Marketing.png";

import tokenDevelopmentImg from "../../images/ServicePageImg/Token Development.png";
import tokenLaunchImg from "../../images/ServicePageImg/Token Launch.png";

import nftMarketplaceImg from "../../images/ServicePageImg/NFT Marketplace.png";
import nftServicesImg from "../../images/ServicePageImg/NFT Services.png";

import digitalMarketingImg from "../../images/ServicePageImg/Digital Marketing.png";



const ServiceSection: React.FC = () => {
  // ========================
  // ICON SVG
  // ========================
  const arrowIcon = (
    <svg
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="6.29004"
        y="21.4111"
        width="22.36"
        height="2.83936"
        transform="rotate(-40.2798 6.29004 21.4111)"
        fill="white"
      />
      <rect
        x="9.44824"
        y="7.57031"
        width="2.83936"
        height="2.83936"
        transform="rotate(-40.2798 9.44824 7.57031)"
        fill="white"
      />
      <rect
        x="13.4492"
        y="7.90015"
        width="2.83936"
        height="2.83936"
        transform="rotate(-40.2798 13.4492 7.90015)"
        fill="white"
      />
      <rect
        x="17.4512"
        y="8.23047"
        width="2.83936"
        height="2.83936"
        transform="rotate(-40.2798 17.4512 8.23047)"
        fill="white"
      />
      <rect
        x="21.123"
        y="12.5627"
        width="2.83936"
        height="2.83936"
        transform="rotate(-40.2798 21.123 12.5627)"
        fill="white"
      />
      <rect
        x="20.793"
        y="16.5649"
        width="2.83936"
        height="2.83936"
        transform="rotate(-40.2798 20.793 16.5649)"
        fill="white"
      />
      <rect
        x="20.4619"
        y="20.5669"
        width="2.83936"
        height="2.83936"
        transform="rotate(-40.2798 20.4619 20.5669)"
        fill="white"
      />
    </svg>
  );

  // ========================
  // ARRAY DATA
  // ========================
   const services = [
    {
      title: "Blockchain Development",
      content:
        "End-to-end blockchain development services delivering secure, scalable, and enterprise-grade decentralized solutions.",
      images: [blockchainDevelopmentImg, blockchainDevelopmentImg, blockchainDevelopmentImg, blockchainDevelopmentImg],
      link: "/blockchain-development",
    },
    {
      title: "Blockchain Consulting",
      content:
        "Strategic blockchain consulting to help businesses adopt the right technology, architecture, and roadmap.",
      images: [blockchainConsultingImg, blockchainConsultingImg, blockchainConsultingImg, blockchainConsultingImg],
      link: "/blockchain-consulting",
    },
    {
      title: "Token Development",
      content:
        "Custom token development using ERC, BEP, and multi-chain standards with secure smart contracts.",
      images: [tokenDevelopmentImg, tokenDevelopmentImg, tokenDevelopmentImg, tokenDevelopmentImg],
      link: "/token-development",
    },
    {
      title: "Token Launch",
      content:
        "Complete token launch services including smart contracts, compliance, listing support, and go-to-market strategy.",
      images: [tokenLaunchImg, tokenLaunchImg, tokenLaunchImg, tokenLaunchImg],
      link: "/token-launch",
    },
    {
      title: "Centralized Crypto Exchange",
      content:
        "Build high-performance centralized crypto exchanges with advanced trading engines and security layers.",
      images: [centralizedCryptoExchangeImg, centralizedCryptoExchangeImg, centralizedCryptoExchangeImg, centralizedCryptoExchangeImg],
      link: "/centralized-crypto-exchange-development",
    },
    {
      title: "Decentralized Crypto Exchange",
      content:
        "Develop decentralized exchanges (DEX) with liquidity pools, smart contracts, and trustless trading.",
      images: [decentralizedCryptoExchangeImg, decentralizedCryptoExchangeImg, decentralizedCryptoExchangeImg, decentralizedCryptoExchangeImg],
      link: "/decentralized-crypto-exchange-development",
    },
    {
      title: "Crypto Listing Services",
      content:
        "Professional crypto listing services to help tokens get listed on top centralized and decentralized exchanges.",
      images: [cryptoListingServicesImg, cryptoListingServicesImg, cryptoListingServicesImg, cryptoListingServicesImg],
      link: "/crypto-listing-service",
    },
    {
      title: "Crypto Marketing",
      content:
        "Result-driven crypto marketing services to grow visibility, community engagement, and token adoption.",
      images: [cryptoMarketingImg, cryptoMarketingImg, cryptoMarketingImg, cryptoMarketingImg],
      link: "/cryptocurrency-marketing-services",
    },
    {
      title: "NFT Marketing",
      content:
        "NFT marketing strategies designed to boost project reach, user engagement, and marketplace traction.",
      images: [nftMarketplaceImg, nftMarketplaceImg, nftMarketplaceImg, nftMarketplaceImg],
      link: "/nft-marketing",
    },
    {
      title: "NFT Services",
      content:
        "Complete NFT services including minting, marketplace integration, royalties, and smart contract development.",
      images: [nftServicesImg, nftServicesImg, nftServicesImg, nftServicesImg],
      link: "/nft-service",
    },
    {
      title: "Digital Marketing",
      content:
        "Digital marketing solutions tailored for blockchain, crypto, and Web3 businesses to scale globally.",
      images: [digitalMarketingImg, digitalMarketingImg, digitalMarketingImg, digitalMarketingImg],
      link: "/digital-marketing",
    },
  ];


  // ========================
  // RETURN SECTION
  // ========================
  return (
    <section
      className="service pos-rel bg_img"
      style={{ backgroundImage: `url(${serviceBg})` }}
    >
      <div className="container">
        <div className="row mt-none-30">
          {services.map((service, index) => (
            <div className="col-lg-6 mt-30 d-flex" key={index}>
              <div className="xb-ser-item xb-border img-hove-effect h-100">
                <div
  className="xb-item--inner"
  style={{
    display: "flex",
    flexDirection: "column",
    height: "100%",
  }}
>

                  <h3 className="xb-item--title border-effect">
                    <Link to={service.link}>{service.title}</Link>
                  </h3>

                  <Link className="xb-item--icon" to={service.link}>
                    {arrowIcon}
                  </Link>

                  <p className="xb-item--content">{service.content}</p>

                  <div
  className="xb-item--img xb-img"
  style={{
    marginTop: "auto",
    paddingBottom: "4px",
  }}
>

                    {service.images.map((img, i) => (
                      <Link key={i} to={service.link}>
                        <img src={img} alt="service" />
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceSection;
